import { taskManagment } from './ReactComponent';

export const ReactHandler = (function () {
  const task = {
    onClick: (task) => {
      taskManagment.clickTaskHandler(task);
    }
  };

  return {
    task
  };
})();
